import type { FC } from "react";

import { useHeaderContext } from "@ui/eva-components/Header/context";
import { RoundButton, useTranslations } from "@ui/index";
import classNames from "classnames";

import { LongArrowForwardIcon } from "@jti/brand-icons/long-arrow-forward";
import { UiCrossIcon } from "@jti/brand-icons/ui-cross";
import { Button } from "@jti/core-components/components/Button";

import styles from "./SubmenuTitle.module.scss";

export type SubmenuTitleProps = {
  title: string;
  variant?: "general" | "ploomClub";
  descriptionPrefix?: string;
  secondDescriptionPrefix?: string;
  link?: {
    text: string;
    href: string;
  };
  showUserTier?: boolean;
};

export const SubmenuTitle: FC<SubmenuTitleProps> = ({
  title,
  variant = "general",
  descriptionPrefix,
  link,
  secondDescriptionPrefix,
  showUserTier,
}) => {
  const { onClick, userTier, loyaltyPoints } = useHeaderContext();
  const { __ } = useTranslations();

  const shouldDisplayLoyaltyData = userTier && loyaltyPoints;

  return (
    <div
      className={classNames(styles.wrapper, {
        [styles.ploomClub]: variant === "ploomClub",
      })}
      data-testid="title"
    >
      <p className={styles.title}>{title}</p>
      {variant === "general" ? (
        <RoundButton
          icon={UiCrossIcon}
          onClick={onClick}
          data-testid="close-icon-wrapper"
          aria-label={__("common.close")}
        />
      ) : (
        <>
          {shouldDisplayLoyaltyData && (
            <div className={styles.textWrapper}>
              {showUserTier && (
                <p className={styles.descriptionStyle}>
                  {descriptionPrefix} <strong>{userTier}</strong>
                </p>
              )}
              <div className={styles.separator}></div>
              <p className={styles.descriptionStyle}>
                {secondDescriptionPrefix} <strong>{loyaltyPoints}</strong>
              </p>
            </div>
          )}
          {link ? (
            <Button href={link.href} variant="text-muted" size="sm" iconAfter={LongArrowForwardIcon}>
              {link.text}
            </Button>
          ) : null}
        </>
      )}
    </div>
  );
};
